/* e(at)-book theme — interactions (no dependencies) */
(function(){
  'use strict';

  // Mobile menu toggle
  var btn = document.querySelector('.menu-btn');
  var menu = document.querySelector('.mobile-menu');
  if (btn && menu){
    btn.addEventListener('click', function(){
      var open = menu.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Reveal-on-scroll
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, {threshold:.12});
    reveals.forEach(function(el){ io.observe(el); });
  } else {
    reveals.forEach(function(el){ el.classList.add('in'); });
  }

  // Lead-magnet capture (front-end demo; wire to Klaviyo/Shopify form in admin)
  document.querySelectorAll('[data-capture]').forEach(function(form){
    form.addEventListener('submit', function(ev){
      ev.preventDefault();
      var ok = form.parentElement.querySelector('.form-success');
      if (ok) ok.classList.add('show');
      form.reset();
    });
  });

  // Sticky CTA: show after scrolling past the hero on mobile
  var sticky = document.querySelector('.sticky-cta');
  if (sticky){
    var onScroll = function(){
      if (window.scrollY > 520) sticky.style.display = '';
      else if (window.innerWidth <= 900) sticky.style.display = 'flex';
    };
    window.addEventListener('scroll', onScroll, {passive:true});
  }
})();
